var $ = window.$ = require('jquery'),
	gc = require('./js/gc'),
	mode = require('./js/mode'),
	ls = require('local-storage'),
	Video = require('./js/video'),
	social = require('./js/social');

require('./js/track');

var $w = $(window),
	$b = $('body');
	
$w.on('gc:scrolling', function(e, st){
	$b[st ? 'addClass' : 'removeClass']('scroll');
	$b[gc.scrollDirection.up ? 'addClass' : 'removeClass']('scroll-up');
});

gc.where('.overlay', function($overlay){
	$overlay.click(mode.clear);
});

if( ! ls.get('has-visited')){
    $('body').addClass('first-visit');
    ls.set('has-visited', 1);
}

if ("ontouchstart" in document.documentElement) {
    document.body.classList.add('touch-device');

} else {
    document.body.classList.add('hover-device');
}

if ($('body').hasClass("touch-device")) {
	//Loading height on touch-device
    function calcFullHeight() {
        $('.slug-intro-animation').css("height", $(window).height());
    }

    (function($) {
        calcFullHeight();

        $(window).on('orientationchange', function() {
            // 500ms timeout for getting the correct height after orientation change
            setTimeout(function() {
                calcFullHeight();
            }, 500);

        });
    })($);

} else {
    $('.full-height').css("height", "100vh");
}
gc.when('figure[data-background]', function( $el ){
	
	var $th = $(this);
		
	if(!$('.img-bg-loader', $th).length)
		$th.append($('<div class="img-bg-loader"></div>'));
		
	$th.addClass('loading');
	
	$th.on('viewport-visible', function(){

		if(!$th.hasClass('loaded')){

			var img = new Image;
			
			$(img).bind('load error', function(e){
				$th.css('background-image', 'url('+$th.attr('src')+')')
					.addClass('loaded')
					.removeClass('loading');
					
				setTimeout(function(){
					$('.img-bg-loader', $th).remove();
				}, 1000);
			});
			
			img.src = $th.attr('src');
		}
	});

	$th.viewportTrack(null, null, true);
});

gc.when('button.toolbar-icon-edit', function($button){
	$button.click(function(){
		$('body').toggleClass('edit-mode');
	});
	if($(window).width() >= 976)
		$('#toolbar-item-administration')[0].click();
});

/* Keep deleting 'Drupal.toolbar.activeTabID' so we don't get the arsehole when resizing window */

setInterval(function(){
	ls.remove('Drupal.toolbar.activeTabID');
}, 1000);

gc.when('article.slug-our-approach', function($article){
	
	var $menu = $('<nav class="anchors"></nav>'),
		$ul = $('<ul></ul>');
		
	$menu.append($ul);
	
	var $header = $('header[role=banner]'),
		ht = parseInt($header.css('top')) + $header.outerHeight();
		
	var $paras = $('.paragraph--type--text-image-combo', $article),
		anchors = {};
		
	var scrolling = false;
	
	$paras.each(function( i ){
	
		var $screen = $(this),
			title = $('.field--name-field-slug', $(this)).html(),
			slug = title.toLowerCase().replace(/\s/g, '-').replace(/[^a-z\-]g/, '');
		
		$screen.attr('data-slug', slug);
		
		var $a = $('<a class="anchor" name="'+slug+'"></a>');
		$screen.prepend($a);
		
		var $li = $('<li data-slug="'+slug+'"><span>'+title+'</span></li>');
		
		$li.click(function(){
		    if(!scrolling) 
			    $([document.documentElement, document.body]).animate({
			        scrollTop: $a.offset().top + 40 - ht
			    }, 500);			
			if( history.pushState )
				history.pushState({}, title, '#'+slug);
			if(!scrolling){
				$paras.removeClass('active');
				$screen.addClass('active');
			}
			$('li', $ul).removeClass('active');
			$li.addClass('active');
		});
				
		$ul.append($li);
		
		anchors[slug] = $li;
	});
	
	$('a[href^="#"]').each(function(){
		var anchor = anchors[this.href.split('#')[1]];
		if( anchor )
			$(this).click(function(e){
				e.preventDefault();
				anchor.click();
			});
	});

	$article.prepend($menu);
	
	$paras.viewportTrack();
	$paras.on('viewport-centered', function(e, a, b){
		var slug = $(this).attr('data-slug');
		scrolling = true;
		anchors[slug].click();
		scrolling = false;
	});
	
	(function(hash){
		hash && anchors[hash].click();
	})((window.location.hash+'').replace(/^\#/,''));
});

gc.where('.slug-intro-animation a', function(a){
	a.click(function(e) {
		e.preventDefault();
	    $([document.documentElement, document.body]).animate({
	        scrollTop: $('video').offset().top 
	    }, 500);		
	});
});


gc.where('body.path-frontpage article.type-news', function($article){
	
	$article.click(function(){
		var w = window.open($('.field--name-field-link a', $article).attr('href'), '_blank');
		w.focus();
	});
});

gc.where('body.slug-news--stories article.type-news', function($article){
	
	$article.click(function(){
		var w = window.open($('.field--name-field-link a', $article).attr('href'), '_blank');
		w.focus();
	});
});

gc.where('video', function( $video ){
	
	var $container = $video.parent(),
		$a = $('.video-link a', $video),
		$button = $('<button class="play"></button>');
	
	$container.append($button);
	$container.attr('data-video-url', $a.attr('href'));
	$button.click(function(){
		Video.createPlayer($container, false);
		$button.remove();
	});
});

gc.where('[data-views=y-analytics-team]', function( $view ){
	
	var $rows = $('.views-row', $view);
	
	$('.views-row', $view).click(function(){
	
		var has = $(this).hasClass('active');
		$rows.removeClass('active');
	
		!has && $(this).addClass('active');
	});
});
Drupal.behaviors.yanaAnalytics = {
  attach: function (context, settings) {
    if (context !== document) {
      return;
    }
    setTimeout(function () {
      if (!Drupal.eu_cookie_compliance.hasAgreed()) {
        window['ga-disable-UA-134056629-1'] = true;
        return;
      }
      window.dataLayer = window.dataLayer || [];

      function gtag() {
        dataLayer.push(arguments);
      }

      gtag('js', new Date());
      gtag('config', 'UA-134056629-1');
    }, 50);
  }
}


//////////////////
// WEBPACK FOOTER
// ./themes/gc/yana.js
// module id = 0
// module chunks = 0